export class GetPortalUserApiRequest {
    QuickFilter: string;
    CustomerId: string;
}